module.exports = {"id":"198335","name":"Bryan Oviedo","rating":"72","photo":"./data/images/photos/4/198335.png","club":{"name":"Sunderland","logo":"./data/images/clubs/Sunderland.png"},"positions":["DG","DLG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BryanOviedo0.json
// module id = 677
// module chunks = 0